// extracted by mini-css-extract-plugin
export default {"countdownSpacer":"_4e9dc4cd","countdownBox":"_e54c2b8e","countdownEnded":"_8d5367d5","link":"_21579daa","warnEnding":"_8af6a40f","circleIcon":"_11269bf3"};